export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">投稿、合作、问题反馈，妖精漫画网随时欢迎你的联系</p>
        </div>
        <div className="max-w-xl mx-auto bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60">
          <div className="flex flex-col sm:flex-row items-start gap-5">
            <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100">
              <i className="ri-mail-send-line text-2xl text-accent-600"></i>
            </div>
            <div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">投稿与咨询</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                如果你有原创漫画作品希望展示，或对妖精漫画网有任何建议与反馈，欢迎通过以下方式联系我们。我们珍视每一位读者和创作者的声音，期待与你一起打造更好的免费漫画阅读平台。
              </p>
              <div className="flex flex-wrap gap-3">
                <a href="#hero" className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors whitespace-nowrap">
                  <i className="ri-chat-3-line"></i>在线留言
                </a>
                <a href="#hero" className="inline-flex items-center gap-2 px-5 py-2.5 border-2 border-background-300 hover:border-primary-400 text-foreground-700 rounded-full text-sm font-medium transition-colors whitespace-nowrap">
                  <i className="ri-mail-line"></i>邮件联系
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}